var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('Title',{attrs:{"title":"Cola de datos","subtitle":"Revisa sus estados y tasa de consumo"}}),_c('el-row',{attrs:{"gutter":30}},_vm._l((_vm.queues),function(queue,index){return _c('Item',{key:index,attrs:{"maxLen":_vm.maxLen,"queue":queue}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }